import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { loadContentCardAnalytics } from 'common/utilities/analyticsUtils';
import { useAppSelector } from '@kfc-global/react-shared/redux/Store/hooks';
import { getPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';
const { MESSAGES_TAG, ZERO_MESSAGE_COUNT_TEXT } = TRANSLATE_MAPPING_KEY;

export const getMessageCountText = (messageCount) => {
  if(messageCount === 0) {
    return <div class='message-not-available'>{translateWithI18Next(ZERO_MESSAGE_COUNT_TEXT)}</div>;
  } else {
    return <div id='message-wrapper'></div>;
  }
}

const MessagePage = props => {
  const { isMobile } = props;
  const [messageCount, setMessageCount] = useState(0);
  const tenantReducer = useSelector(data => data.tenantReducer || null);
  const toCallShowContentCardsFromDisplay = tenantReducer?.componentOptions?.web?.global?.loadBrazeData;
  const getPwaStorageData = useAppSelector(getPWAstorage);
  const { SingleArrowback } = IMAGE_PATH;
  const brazeCount = getPwaStorageData?.brazeInitialized && window?.appboy?.getCachedContentCards()?.cards.length

  useEffect(() => {
    (async () => {
      await loadContentCardAnalytics();
      const msgWrapper = document.getElementById('message-wrapper');
      brazeCount && setMessageCount(brazeCount);
      toCallShowContentCardsFromDisplay ?  getPwaStorageData?.brazeInitialized && window?.appboy?.showContentCards(msgWrapper) : getPwaStorageData?.brazeInitialized && window?.appboy?.display?.showContentCards(msgWrapper);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPwaStorageData?.brazeInitialized, brazeCount]);

  return (
    <div data-testid='account-message-wrapper' className='account-message-wrapper'>
      {isMobile && (
        <div className='account-message-header-mobile'>
          <img
            className='backArrow-account-setting'
            data-testid='message-backArrow'
            onClick={() => props.updateMenu('')}
            src={SingleArrowback}
            alt='back button'
          />
          <span className='account-message-text-header'>{translateWithI18Next(MESSAGES_TAG)}</span>
        </div>
      )}
      <span className='account-message-text-heading'>
        {translateWithI18Next(MESSAGES_TAG)} {`(${messageCount})`}
      </span>
      <div id='message-wrapper'></div>
    </div>
  );
};

export default MessagePage;
